import React, { Component, ReactNode } from "react";
import { ScreenCloud } from "../../ScreenCloudReactApp";
import "../../index.css";
import SlideShow from "../../components/SlideShow";

interface State {
  url: string;
  validUrl: boolean;
}

interface Props {
  sc: ScreenCloud;
}

export class AppContainer extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    // props url
    const url = this.props.sc.config.url;

    this.state = {
      url: url,
      validUrl: true,
    };
  }

  componentDidMount(): void {
    this.checkIframe();
    return;
  }

  checkIframe = (): void => {
    // This checks if the iframe given by the custommer is correct. If not it will set validUrl
    // to false and it will display an error screen. If it is valid it will not show
    // an error screen
    const { url } = this.props.sc.config;
    let { validUrl } = this.state;
    validUrl = url.includes("https://www.canva.com/design");
    this.setState({
      validUrl,
    });
  };

  render(): ReactNode {
    const { validUrl } = this.state;

    if (!validUrl) {
      return (
        <div className="app-container">
          <div className="url-error">
            <p>
              The provided url does not match the expected format of
              https://www.canva.com/design...
            </p>
          </div>
          <div className="screensize-error">
            <p>We do not support this app in this layout.</p>
          </div>
        </div>
      );
    }

    return (
      <div className="app-container">
        <SlideShow />
      </div>
    );
  }
}
